import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChipComponent, IsDefinedNotEmptyPipe } from '@softline/ui-core';
import { Product } from '@softapps/wws/core';

@Component({
    selector: 'soft-product-card',
    imports: [CommonModule, IsDefinedNotEmptyPipe, ChipComponent],
    templateUrl: './product-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './product-card.component.css'
})
export class ProductCardComponent {
  product = input<Product | null | undefined>(null);

  statusColor(statusType: string | undefined) {
    switch (statusType) {
      case 'LISTED':
        return '!bg-success'
      case 'ORDER':
        return '!bg-warning';
      case 'DISCUNTINUED':
        return '!bg-error-300';
      case 'DELISTED':
        return '!bg-error';
      default:
        return '!bg-secondary'
    }
  }
}
